<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.QueryLCLJobOrder')"
    width="1085px"
    append-to-body
    :close-on-click-modal="false"
    :before-close="beforeCloseHandler"
    class="app-main-inner query-lcl-dialog"
  >
    <div class="app-main-inner-row">
      <search-item
        ref="searchItem"
        config-module="201"
        :reset="true"
        :show-simple="false"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        :col-settings="{span:8}"
        grid-config-module="201001"
        @advSearchItemCallBack="toQuery"
        @perConfigChange="value=>{perConfigName=value}"
        @refreshGrid="()=>{gridRefreshId+=1}"
      />
    </div>
    <div class="app-main-inner-row">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="height: 300px"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        config-module="201001"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div slot="footer" style="display: flex;justify-content: space-between;">
      <span>
        <b>{{ $t('SeaExport.QuantityOfSelectedOrder') }}：{{ selectedRows.length }}</b>
      </span>
      <div>
        <el-button type="primary" @click="add">{{ $t('SeaExport.Add3') }}</el-button>
        <el-button @click="beforeCloseHandler(()=>{innerVisible=false})">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { getSeaImportJobsByLclMasterJobFunc } from '@/api/SeaImport/seaImportJob'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { cache, cacheName } from '@/utils/cacheManager'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'QueryLclDialog',
  components: { searchItem },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      filter: {},
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 重置（多选）选中行
          this.selectedRows = []
        },
        onSelectionChanged: event => {
          this.selectedRows = event.api.getSelectedRows()
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 40,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo',
          width: 130
        }, {
          headerName: this.$t('Payment.warehouseNo'),
          field: 'warehouseNo',
          width: 120
        }, {
          headerName: 'MBL',
          field: 'mbl',
          width: 90
        }, {
          headerName: this.$t('Payment.consignationCompany'),
          field: 'customerId',
          width: 220,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.bookingAgent'),
          field: 'bookingAgent',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('queryJob.dischargingPortCode'),
          field: 'dischargingPortCode',
          width: 130/*,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }*/
        }, {
          headerName: 'ETD',
          field: 'etd',
          width: 90,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CargoName'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityContract',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightContract',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubageContract',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ItemNo'),
          field: 'poNo',
          width: 120
        },
        { headerName: this.$t('SeaExport.Operation'), field: 'op', width: 120, colId: 'op', hide: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op') : ''
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      customSearchItems: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.filter = {}
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initData() {
      await cache.load(cacheName.CONFIG)
      const isJyd = String(cache.config.get('ToExoSystem')) === 'JYD'
      const isAdmin = this.$store.getters.isAdmin

      // CARGO-28997 【加入小票】优化前端提示
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'siJob.CONTAINER_LOAD_TYPE'
      searchField.itemLabel = 'SeaExport.FLCLType'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.valueExpression = ''
      searchField.dropdownDataRef = 'ImportConstants._cargoTypeInputList'
      searchField.dataCacheKey = 'local_cache_ImportConstants$_cargoTypeInputList'
      searchField.defaultValue = ['LCL']
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      // 操作部门使用主票操作部门，且不可编辑
      searchField = new AdvancedSearchField()
      searchField.itemType = 'department5'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_DEPARTMENT5'
      searchField.itemName = 'job.OP_DEPARTMENT'
      searchField.itemLabel = 'SeaExport.OperationDepartment'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = [this.job.opDepartment]
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      // CARGO-42713 加入小票查询权限逻辑优化-只能操作看自己的
      searchField = new AdvancedSearchField()
      searchField.itemType = 'user'
      searchField.subType = {
        'category': 'role',
        'shape': 'op'
      }
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_USER'
      searchField.itemName = 'job.OP_ID'
      searchField.itemLabel = 'SeaExport.Operation'
      searchField.itemValue = ''
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = (isJyd && !isAdmin)
      searchField.defaultValue = (isJyd && !isAdmin) ? this.$store.getters.userId : 0
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())

      searchField = new AdvancedSearchField()
      searchField.itemType = 'seaport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_SEAPORT'
      searchField.itemName = 'job.LOADING_PORT_CODE'
      searchField.itemLabel = 'SeaExport.PortOfLoading'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = this.job.loadingPortCode
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      searchField = new AdvancedSearchField()
      searchField.itemType = 'seaport'
      searchField.multiple = 0
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_SEAPORT'
      searchField.itemName = 'job.DISCHARGING_PORT_CODE'
      searchField.itemLabel = 'SeaExport.PortOfDischarge'
      searchField.itemValue = []
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.lock = true
      searchField.defaultValue = this.job.dischargingPortCode
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
    },
    toQuery(data) {
      this.filter.conditions = [... data]
      this.filter.branchId = this.$store.getters.currentOfficeId
      getSeaImportJobsByLclMasterJobFunc(this.filter).then(res => {
        this.rowData = res.data
      })
    },
    add() {
      const selectedRows = this.selectedRows // 记录当前选中的记录，避免后续被修改
      if (selectedRows.length === 0) {
        this.$message.info(this.$t('Message.SelectTheOrderYouWantToJoin'))
        return
      }
      for (const job of selectedRows) {
        if (job.lclMasterUuid) {
          this.$message.warning(job.jobNo + ' ' + this.$t('Message.HasJoinIntoMbl'))
          return
        }
      }
      const triggerCallback = () => {
        // 后端处理刷加入的小票上的相关信息；进口刷新小票仓库信息
        /* this.fixNewSlave()
        this.addToLclMaster()*/
        this.$emit('callback', selectedRows)
      }

      if (!this.checkNewSlave(selectedRows)) {
        this.$confirm(`${this.$t('Message.TheAndFreightTermsBlank')}\r\n${this.$t('Message.TheModifyTheSmallContinue')}`
          , this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
          triggerCallback()
          this.innerVisible = false
        }).catch(() => { })
      } else {
        triggerCallback()
        this.innerVisible = false
      }
    },
    checkNewSlave(selectedRows) {
      for (const slave of selectedRows) {
        if (slave.vessel !== this.job.vessel) {
          return false
        }
        if (slave.voyageFlight !== this.job.voyageFlight) {
          return false
        }
        if (slave.carrierId !== this.job.carrierId) {
          return false
        }
        if (!(!slave.eta && !this.job.eta) && (!slave.eta && this.job.eta || slave.eta && !this.job.eta || slave.eta !== this.job.eta)) {
          return false
        }
        if (!(!slave.ata && !this.job.ata) && (!slave.ata && this.job.ata || slave.ata && !this.job.ata || slave.ata !== this.job.ata)) {
          return false
        }
        if (slave.mbl !== this.job.mbl) {
          return false
        }
        if (slave.releaseTypeMBL !== this.job.releaseTypeMBL) {
          return false
        }
        if (slave.paymentTermMBL !== this.job.paymentTermMBL) {
          return false
        }
      }
      return true
    },
    beforeCloseHandler(done) {
      this.$confirm(this.$t('Message.CancelTheCurrentQuery'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss">
.app-main-inner.query-lcl-dialog {
  label {
    font-size: 12px;
    font-weight: normal;
  }
  .el-select {
    width: 100%;
  }
}
</style>
